export const BASE_PATH_HOME = "/";
export const PATH_HOME = "/profile/";
